// extracted by mini-css-extract-plugin
export default {"content":"styles-module--content--exfMr"};